// Attribute is different if the product has been added using the old API or the new one 
export default (wishlistProduct) => {
  let wishlist_product_id = null;
  if (typeof wishlistProduct.id !== 'undefined') {
    wishlist_product_id = wishlistProduct.id;
  } else if (typeof wishlistProduct._id !== 'undefined') {
    wishlist_product_id = wishlistProduct._id;
  }

  return wishlist_product_id;
};
